import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_PATRIMONIO_MANUTENCAO_CADASTRO_RAPIDO,
    CANCEL_PATRIMONIO_MANUTENCAO_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelPatrimonioManutencaoCadastroRapido() {
  yield put({ type: CANCEL_PATRIMONIO_MANUTENCAO_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelPatrimonioManutencaoCadastroRapido() {
  yield takeLatest(CANCEL_PATRIMONIO_MANUTENCAO_CADASTRO_RAPIDO, sagaCancelPatrimonioManutencaoCadastroRapido)
}
